import styled from 'styled-components';

import { HEADER_HEIGHT } from '@/core/components/Layout/Layout.styles';
import { PANEL_WIDTH } from '@/core/components/CollapsiblePanel/CollapsiblePanel.styles';

export const ChatBotWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT});
  min-height: 0;
  max-height: calc(100vh - ${HEADER_HEIGHT});
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.background.dark};
`;

export const ChatContentWrapper = styled.div<{ $isSidePanelOpen: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  margin-left: ${({ $isSidePanelOpen }) => ($isSidePanelOpen ? PANEL_WIDTH : 0)};
  border-left: ${({ $isSidePanelOpen, theme }) =>
    $isSidePanelOpen ? `1px solid ${theme.colors.background.extraLight}` : 'none'};
  background: ${({ theme }) => theme.colors.background.dark};
  transition: margin 0.3s ease-in-out;
`;

export const ChatContentContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export const InitialPromptArea = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 0;
  padding: 24px;
`;

export const ScrollToBottomWrapper = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
  pointer-events: none;
`;

export const ScrollToBottomButton = styled.button`
  position: absolute;
  right: 16px;
  bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 0;
  border-radius: 999px;
  padding: 12px;
  background: ${({ theme }) => theme.colors.background.light};
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12px;
  pointer-events: auto;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
